import { render, staticRenderFns } from "./WordCloud_su2.vue?vue&type=template&id=a749af62&scoped=true"
import script from "./WordCloud_su2.vue?vue&type=script&lang=js"
export * from "./WordCloud_su2.vue?vue&type=script&lang=js"
import style0 from "./WordCloud_su2.vue?vue&type=style&index=0&id=a749af62&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a749af62",
  null
  
)

export default component.exports